<template>
  <div>
    <ReceivedFilter
      :csv-filter-options="displayedFilterOptions"
      :already-selected-displayed-columns="filtersData?.displayedColumns"
      :show-received-by-filter="showRecievedBy"
      :options-list="viewsList"
      :is-additional-filter="true"
      default-view="fee summary"
      @updateAdditionalFilterValue="changeView"
      @apply="applyFilters"
    />
    <div>
      <div v-if="isLoading" class="mt-28">
        <Loader :content="true" />
      </div>
      <div
        v-else-if="
          !isLoading && isEmpty(studentReceivedFees) && isEmpty(studentReceivedInstallments)
        "
      >
        <NoRecordFound />
      </div>
      <TableWrapper v-else>
        <THead>
          <TRHead>
            <TH
              v-for="head in tableHeaders.filter((head) => !head.skipForDataTableHead)"
              v-show="showColumnInDataTable(filtersData, head.dataTableName, skipForFilterColumns)"
              :key="head.id"
            >
              <span v-i18n="fees">
                {{ head.dataTableName }}
              </span>
            </TH>
            <TH v-if="viewMode === 'fee summary'" v-permission="classLevelPermission">
              {{ pluralToSingular(sectionName).toLowerCase() }}
            </TH>
          </TRHead>
        </THead>
        <TBody v-if="viewMode === 'fee summary'">
          <TRBody v-for="(fee, index) in studentReceivedFees" :key="index">
            <TD>
              <div
                @click="
                  ;[
                    isAllowedRedirectToPaidByRole &&
                      redirectToStudentMode(fee.student, 'received', 'student-fee-received'),
                  ]
                "
              >
                <SingleUserDisplay
                  :required-items="1"
                  :user="fee.student"
                  label="full_name"
                  :image="true"
                  :dropdown-top-bottom="
                    dropdownTopBottom(index, studentReceivedFees, 'bottom-6', 'top-6')
                  "
                  :tooltip="
                    dropdownTopBottom(index, studentReceivedFees, 'tooltip-bottom', 'tooltip-top')
                  "
                />
              </div>
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Student Email')" :lowercase="true">
              {{ (fee.student && fee.student.email) || GENERAL_CONSTANTS.NOT_APPLICABLE }}
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Student Phone')">
              <ReadOnlyPhoneNumberInDataTable :phone="fee.student?.phone" />
            </TD>
            <TD>
              <div
                v-if="
                  fee.student?.student_info.guardians && fee.student?.student_info.guardians.length
                "
              >
                <MultiUserDisplay
                  :options="fee.student?.student_info.guardians"
                  label="full_name"
                  :image="true"
                  :dropdown-top-bottom="
                    dropdownTopBottom(index, studentReceivedFees, 'bottom-6', 'top-6')
                  "
                  :tooltip="
                    dropdownTopBottom(index, studentReceivedFees, 'tooltip-bottom', 'tooltip-top')
                  "
                />
              </div>
              <span v-else>
                {{ GENERAL_CONSTANTS.NOT_APPLICABLE }}
              </span>
            </TD>
            <TD>
              <span
                :class="{
                  'cursor-pointer text-primary-purple-600': fee.section_fee || fee.title,
                }"
                @click="goToSectionFeeDetail(fee)"
              >
                {{
                  fee.section_fee
                    ? fee.section_fee.title
                    : fee.title || GENERAL_CONSTANTS.NOT_APPLICABLE
                }}
              </span>
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Fee Type')">
              {{ fee.fee_type.title }}
            </TD>
            <TD>
              <span class="cursor-pointer text-primary-purple-600" @click="goToDetailPage(fee)">
                {{ fee.fee_amount }}
              </span>
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Paid')">
              {{ fee.paid_amount }}
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Payable')">
              {{ fee.payable_amount }}
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Discount')">
              {{ fee.discount_amount }}
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Fine')">
              {{ fee.fine_amount }}
            </TD>
            <TD>
              <MultiUserDisplay
                v-if="
                  !isEmpty(fee.student_fee_receivings) &&
                  fee.student_fee_receivings.some((val) => val.received_by)
                "
                :options="fee.student_fee_receivings.filter((val) => !!val.received_by)"
                :nested-label="['received_by', 'full_name']"
                detail="collection_no"
                :image="true"
                :dropdown-top-bottom="
                  dropdownTopBottom(index, studentReceivedFees, 'bottom-6', 'top-6')
                "
                :tooltip="
                  dropdownTopBottom(index, studentReceivedFees, 'tooltip-bottom', 'tooltip-top')
                "
                :is-object-concated="false"
              />
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Currency')">
              <span class="uppercase">
                {{ fee.currency }}
              </span>
            </TD>
            <TD>
              {{
                isEmpty(fee.student_fee_receivings)
                  ? ''
                  : $filters.formattedDate(fee.student_fee_receivings[0].paid_date)
              }}
            </TD>
            <TD>
              {{ $filters.formattedDate(fee.inserted_at) }}
            </TD>
            <TD>
              {{ $filters.formattedDate(fee.due_date) }}
            </TD>
            <TD>
              <PaymentStatus :status="fee.status" />
            </TD>
            <TD v-permission="classLevelPermission">
              {{ fee.section.title }}
            </TD>
          </TRBody>
        </TBody>
        <TBody v-else>
          <TRBody v-for="(fee, index) in studentReceivedInstallments" :key="index">
            <TD>
              <div
                @click="
                  ;[
                    isAllowedRedirectToPaidByRole &&
                      redirectToStudentMode(
                        fee.student_fee.student,
                        'received',
                        'student-fee-received',
                      ),
                  ]
                "
              >
                <SingleUserDisplay
                  :required-items="1"
                  :user="fee.student_fee.student"
                  label="full_name"
                  :image="true"
                  :dropdown-top-bottom="
                    dropdownTopBottom(index, studentReceivedInstallments, 'bottom-6', 'top-6')
                  "
                  :tooltip="
                    dropdownTopBottom(
                      index,
                      studentReceivedInstallments,
                      'tooltip-bottom',
                      'tooltip-top',
                    )
                  "
                />
              </div>
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Student Email')">
              {{
                (fee.student_fee.student && fee.student_fee.student.email) ||
                GENERAL_CONSTANTS.NOT_APPLICABLE
              }}
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Student Phone')">
              <ReadOnlyPhoneNumberInDataTable :phone="fee.student_fee.student?.phone" />
            </TD>
            <TD>
              <div>
                <MultiUserDisplay
                  :options="fee.student?.student_info?.guardians"
                  label="full_name"
                  :image="true"
                  :dropdown-top-bottom="
                    dropdownTopBottom(index, studentReceivedFees, 'bottom-6', 'top-6')
                  "
                  :tooltip="
                    dropdownTopBottom(index, studentReceivedFees, 'tooltip-bottom', 'tooltip-top')
                  "
                />
              </div>
            </TD>
            <TD
              :class="{
                'cursor-pointer text-primary-purple-600 lg:px-6 px-3.5':
                  fee.student_fee.section_fee,
              }"
              @click="goToSectionFeeDetail(fee.student_fee)"
            >
              {{
                fee.student_fee.section_fee
                  ? fee.student_fee.section_fee.title
                  : GENERAL_CONSTANTS.NOT_APPLICABLE
              }}
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Fee Type')">
              {{ fee.student_fee.fee_type.title }}
            </TD>
            <TD
              class="text-primary-purple-600 cursor-pointer lg:px-6 px-3.5"
              @click="goToDetailPage(fee.student_fee)"
            >
              {{ fee.student_fee.fee_amount }}
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Paid')">
              {{ fee.paid_amount }}
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Payable')">
              {{ fee.payable_amount }}
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Discount')">
              {{ fee.student_fee.discount_amount }}
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Fine')">
              {{ fee.student_fee.fine_amount }}
            </TD>
            <TD>
              <div>
                <SingleUserDisplay
                  :required-items="1"
                  :user="fee.received_by"
                  label="full_name"
                  :image="true"
                  :dropdown-top-bottom="
                    dropdownTopBottom(index, studentReceivedInstallments, 'bottom-6', 'top-6')
                  "
                  :tooltip="
                    dropdownTopBottom(
                      index,
                      studentReceivedInstallments,
                      'tooltip-bottom',
                      'tooltip-top',
                    )
                  "
                />
              </div>
            </TD>
            <TD v-show="showColumnInDataTable(filtersData, 'Currency')">
              {{ fee.student_fee.currency }}
            </TD>
            <TD>{{ $filters.formattedDate(fee.paid_date) }}</TD>
            <TD>
              {{ $filters.formattedDate(fee.student_fee.due_date) }}
            </TD>
          </TRBody>
        </TBody>
      </TableWrapper>
      <Pagination
        v-if="showPagination"
        v-show="!isLoading"
        :record-limit="filteredRecordLimit"
        :max-range="paginationCounts(recordsCountForPagination, filteredRecordLimit)"
        @filterRecord="filterRecord"
      />
    </div>
  </div>
</template>

<script>
import ReceivedFilter from '@/src/router/views/finance/fees/received/ReceivedFilter.vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import Pagination from '@components/BaseComponent/Pagination.vue'
import Loader from '@components/BaseComponent/Loader.vue'
import GeneralUtil from '@src/mixins/general-mixins.js'
import isEmpty from 'lodash/isEmpty'
import PaymentStatus from '@/src/router/views/finance/fees/feeActionsModals/PaymentStatus.vue'
import {
  dropdownTopBottom,
  showColumnInDataTable,
  findCurrencyById,
  pluralToSingular,
} from '@utils/generalUtil'
import ReadOnlyPhoneNumberInDataTable from '@src/components/UiElements/PhoneDisplay.vue'
import { redirectToStudentMode } from '@src/utils/settings/tenant-user.util.js'
import NoRecordFound from '@/src/components/BaseComponent/NoRecordFound.vue'
import scrollMixin from '@src/mixins/scroll-mixin'
import SingleUserDisplay from '@src/components/UiElements/SingleUserDisplay.vue'
import MultiUserDisplay from '@/src/components/UiElements/MultiUserDisplay.vue'
import receivedData from '@src/router/views/finance/fees/received/received.json'
import fileMixin from '@src/mixins/file-mixins'
import { rightBarStats } from '@/src/router/views/finance/fees/received/received.util.js'
import GENERAL_CONSTANTS, { SCOPE_LEVELS } from '@src/constants/general-constants.js'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import {
  TableWrapper,
  TBody,
  TD,
  TH,
  THead,
  TRBody,
  TRHead,
} from '@src/components/UiElements/TableElements/index.js'
export default {
  components: {
    ReceivedFilter,
    Pagination,
    Loader,
    PaymentStatus,
    ReadOnlyPhoneNumberInDataTable,
    NoRecordFound,
    SingleUserDisplay,
    MultiUserDisplay,
    TableWrapper,
    TBody,
    TD,
    TH,
    THead,
    TRBody,
    TRHead,
  },
  mixins: [GeneralUtil, scrollMixin, fileMixin],

  data() {
    return {
      isEmpty,
      GENERAL_CONSTANTS,
      SCOPE_LEVELS,
      campusLevelPermisions: {
        env: ['prod'],
        basedOn: ['campus-level'],
      },
      tableHeads: receivedData.tableHeaders,
      fees: 'fees',
      dashboard: 'dashboard',
      filteredRecordLimit: 10,
      isLoading: false,
      currentUserPosition: '',
      currentUser: {},
      skipForFilterColumns: receivedData.skipForFilterColumns,
      showRecievedBy: false,
      showPagination: false,
      tempDate: {},
      currentDate: null,
      defaultSelectedColumns: receivedData.defaultSelectedColumns,
      filtersData: {},
      viewsList: ['fee summary', 'installments'],
      viewMode: 'fee summary',
      recordsCountForPagination: 0,
      classLevelPermission: {
        basedOn: [SCOPE_LEVELS.CLASS_LEVEL],
      },
    }
  },

  computed: {
    ...mapGetters('featureNaming', ['sectionName']),
    currencySymbol() {
      return findCurrencyById()?.symbol
    },
    ...mapState({
      showModal: (state) => state.layout.showModal,
      showUiModal: (state) => state.layout.showUiModal,
      studentReceivedFees: (state) => state.fee.studentReceivedFees?.records || [],
      studentReceivedFeesCounts: (state) => state.fee.studentReceivedFees.meta?.total_records,
      studentReceivedInstallments: (state) => state.fee.studentReceivedInstallments?.records || [],
      studentReceivedInstallmentsCounts: (state) =>
        state.fee.studentReceivedInstallments?.meta?.total_records,
      currentSectionScope: (state) => state.layout.currentSectionScope,
      currentCampusScope: (state) => state.layout.currentCampusScope,
      currentClassScope: (state) => state.layout.currentClassScope,
    }),
    ...mapState('layout', ['activeRole']),
    isStudentOrGuardian() {
      return [TENANT_ROLES.SECTION_STUDENT, TENANT_ROLES.GUARDIAN].includes(this.activeRole)
    },
    alwaysDisplayColumnsForCSV() {
      let alwaysdisplayedColumns = {}
      if (this.viewMode === 'fee summary') {
        alwaysdisplayedColumns = {
          'student.first_name': 'First Name',
          'student.last_name': 'Last Name',
        }
      } else {
        alwaysdisplayedColumns = {
          'student_fee.student.first_name': 'First Name',
          'student_fee.student.last_name': 'Last Name',
        }
      }
      return alwaysdisplayedColumns
    },
    tableHeaders() {
      let response
      if (this.viewMode === 'installments') {
        response = this.tableHeads.filter(
          (head) => head.dataTableName !== 'Status' && head.dataTableName !== 'Created At',
        )
      } else {
        response = this.tableHeads
      }
      return response
    },

    isAllowedRedirectToPaidByRole() {
      let rolesList = ['section_student', 'gaurdian']
      return !rolesList.includes(this.activeRole)
    },
  },

  watch: {
    viewMode: {
      handler(val) {
        this.showRecievedBy = val === 'installments'
      },
    },

    studentReceivedFeesCounts: {
      handler(val) {
        if (val) {
          this.recordsCountForPagination = val
        }
      },
    },
    studentReceivedInstallmentsCounts: {
      handler(val) {
        if (val) {
          this.recordsCountForPagination = val
        }
      },
    },
    currentSectionScope: {
      handler() {
        this.filterRecord()
      },
    },
    currentCampusScope: {
      handler(val) {
        if (val) this.filterRecord()
      },
    },
    currentClassScope: {
      handler() {
        this.filterRecord()
      },
    },
  },

  /**
   * Created hook
   * @description Setting static right bar data
   */
  created() {
    this.currentDate = new Date()
  },
  /**
   * Mounted hook
   * @description Calling FilterRecord method
   */
  mounted() {
    this.setRightBarData()
    this.filterRecord()
  },
  methods: {
    pluralToSingular,
    dropdownTopBottom,
    redirectToStudentMode,
    showColumnInDataTable,
    changeView(view) {
      this.viewMode = view
      this.filterRecord()
    },
    applyFilters(filtersPayload) {
      this.filtersData = filtersPayload
      this.filterRecord()
    },
    goToSectionFeeDetail(fee) {
      if (!fee.section_fee && !fee.title) return
      localStorage.setItem('redirectTo', this.isStudentOrGuardian ? 'student-paid' : 'received')

      if (fee.section_fee)
        this.$router?.push({ name: 'section-fee-details', params: { id: fee.section_fee.id } })
      else this.$router?.push({ name: 'fee-details', params: { id: fee.id } })
    },
    goToDetailPage(fee) {
      localStorage.setItem('redirectTo', this.isStudentOrGuardian ? 'student-paid' : 'received')
      this.$router?.push({ name: 'fee-details', params: { id: fee.id } })
    },

    /**
     * Filter Record
     * @param {number} range
     * @returns {void}
     * @description Method description
     * -  Filter the record on the basis of range
     * -  Setting right bar data
     */
    filterRecord(range) {
      if (!this.currentCampusScope) return
      this.isLoading = true
      this.$store.commit('fee/INIT_RECEIVED_FEE_STATES')
      let payload = {
        skip: range?.skip || GENERAL_CONSTANTS.RECORD_SKIP,
        limit: range?.limit || GENERAL_CONSTANTS.RECORD_LIMIT,
      }
      payload = this.filtersData ? { ...payload, ...{ $where: this.filtersData?.$where } } : payload
      if (this.viewMode === 'fee summary')
        this.getStudentsReceivedFees(payload)
          .then(() => {
            this.showPagination = this.studentReceivedFeesCounts > GENERAL_CONSTANTS.RECORD_LIMIT
            this.getFeeReceivedStats(payload).then((response) => {
              let stats = response.data
              if (this.$route?.name === 'received') this.setRightBarData(stats)
            })
          })
          .finally(() => {
            this.isLoading = false
          })
      else
        this.getStudentFeeReceivings(payload)
          .then(() => {
            this.showPagination =
              this.studentReceivedInstallmentsCounts > GENERAL_CONSTANTS.RECORD_LIMIT
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    /**
     * Set Right Bar Data
     * @description Set RightBar data after API response with real stats
     */
    setRightBarData(stats) {
      const rightBarContent = {
        header: {
          title: ['section_student', 'guardian'].includes(this.activeRole)
            ? 'PAID_FEES'
            : 'Fee Received',
          buttons: [],
        },
        stats: rightBarStats(stats, this.currencySymbol),
      }
      rightBarContent.header.buttons = this.currentSectionScope
        ? [
            {
              title: 'DOWNLOAD_CSV',
              icon: 'download',
              iconHeight: '18',
              iconWidth: '18',
              classes: ['primary-button-right'],
              action: {
                func: () =>
                  this.downloadCSV(
                    this.viewMode === 'fee summary' ? 'receivedList' : 'receivedInstallementList',
                    { $where: this.filtersData?.$where },
                  ),
              },
              permissions: {
                basedOn: ['section-level'],
              },
            },
          ]
        : []
      this.setRightbarContent(rightBarContent)
    },

    /**
     * Handle click
     * @param {string} eventName
     * @returns {void}
     * @description Calling setShowModal and setShowUiModal method on the basis of event name
     */
    handleClick(eventName) {
      switch (eventName) {
        case 'showModalOpen':
          this.setShowModal(true)
          this.setShowUiModal(true)
          break
        case 'close':
          this.setShowModal(false)
          this.setShowUiModal(false)
          break
        case 'cancel':
          this.setShowModal(false)
          this.setShowUiModal(false)
          break
        case 'confirm':
          break
      }
    },

    ...mapActions('layout', ['setRightbarContent', 'setShowModal', 'setShowUiModal']),
    ...mapActions('fee', [
      'getStudentsReceivedFees',
      'getStudentFeeReceivings',
      'getFeeReceivedStats',
    ]),
  },
}
</script>
